module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Workspace Management","payment":"Payment","description":"Add a credit or debit card to make your purchase."},"th":{"title":"ระบบจัดการเวิร์คสเปซ","payment":"การชำระเงิน","description":"เพิ่มการรับรองรูปแบบการชำระเงินด้วยบัตรเดบิตและเครดิต"}}')
  delete Component.options._Ctor
}
